<template>
  <div
    class="page-cover flex-row justify-center word-popover"
    :class="aiTheme"
    style="max-width: 100%"
  >
    <div class="page-cover_word flex-column flex-wrap cursor-pointer" style="max-width: 100%">
      <h3>
        <span>{{ props.sentence }}</span>
        <span>
          <i
            id="ai-sentence-audio"
            class="iconfont"
            :class="bofangIcon"
            style="color: #2bca9c; margin-left: 2vw; vertical-align: middle"
            @click="audioPlay"
          ></i>
        </span>
      </h3>
      <p class="phonetic">{{ phoneticObj["us"] }} {{ phoneticObj["uk"] }}</p>
      <ul class="translate">
        <li v-for="(paraphrase, index) in transList" :key="index" class="translate-content">
          {{ paraphrase }}
        </li>
      </ul>
      <p class="mb-3">{{ props.gptStr }}</p>
      <ion-button class="page-cover_word-button" shape="round" @click="putIntoGlossary"
        >加入生词本
      </ion-button>
    </div>
  </div>
</template>

<script setup lang="ts">
/* disabled-eslint */
import { IonButton, popoverController } from "@ionic/vue";
import http from "@/js/http";
import store from "@/js/store";
import { defineProps, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useStorage } from "@vueuse/core/index";
import getOssPlayInstance from "@/js/ossPlay";

const props = defineProps(["sentence", "gptStr", "word"]);
const audioPlayer = ref();
const mediaType = ref();
const aiTheme = useStorage("ai-theme", "brown", localStorage);
const bofangIcon = ref("icon-bofang3");
const timer = ref(0);
const transList = ref([]);
const phoneticObj = ref({});
const audioInstance = ref({ progress: 0 });

watch(
  () => audioInstance.value.progress,
  () => {
    bofangIcon.value = `icon-bofang${1 + (Math.trunc(audioInstance.value.progress / 18) % 3)}`;
    if (audioInstance.value.progress === 100) {
      bofangIcon.value = "icon-bofang3";
    }
  },
  { deep: true }
);

//查询阅读理解文章
function queryReadingWord() {
  http.get("/readingVocabulary/getReadingWordDetail?word=" + props.sentence).then((res) => {
    if (res.data.success) {
      transList.value = res.data.list;
      const usPhonetic = res.data.dataMap?.["us"]
        ? res.data.dataMap["us"]
            .split(", ")
            .map((i: any) => `/${i.trim()}/`)
            .join(" ")
        : "";
      const ukPhonetic = res.data.dataMap?.["uk"]
        ? res.data.dataMap["uk"]
            .split(",")
            .map((i: any) => `/${i.trim()}/`)
            .join(" ")
        : "";
      phoneticObj.value = { us: usPhonetic, uk: ukPhonetic };
    }
  });
}

async function putIntoGlossary() {
  const appointment = store.getAppointment();
  const params = {
    aptmId: appointment.aptmId,
    courseId: appointment.courseId,
    word: props.sentence.trim(),
    courseType: appointment.courseType,
  };

  http.post("/readingVocabulary/addReadingWordToPersonal", params).then(async (res) => {
    if (res.data.success) {
      let data = res.data.data;
      if (data?.vocabularyId) {
        const appointment = store.getAppointment();
        const params = {
          list: [
            {
              studentId: appointment.studentId,
              vocabularyId: data.vocabularyId,
              mastery: 1,
              selected: 2,
            },
          ],
          studentId: appointment.studentId,
          aptmId: appointment.aptmId,
          total: 1,
          yesNum: 0,
          notNum: 0,
          courseId: appointment.courseId,
        };
        http.post("/vocabulary/beginReviewClassAndUpdateMastery", params).catch((err) => {
          console.log(err);
        });
      }
      popoverController.dismiss({ status: "关闭popover" }).catch((e) => console.log(e));
      await openMsgToast(res.data.messageExtra);
    } else {
      await openMsgToast("加入生词本失败");
    }
  });
}

function audioStop() {
  audioInstance.value.stop();
}

function audioPlay() {
  audioInstance.value = getOssPlayInstance().init({ msg: props.word });
  audioInstance.value.play();
}

onBeforeUnmount(() => {
  audioStop();
});
onMounted(() => {
  // 初始化 Audio 播放器
  /* eslint-disable */
  // audioPlayer.value = new AudioPlayer("/assets/js");
  queryReadingWord()
})
</script>

<style>
ion-popover::part(content) {
  --width: none !important;
  --max-width: 500px; /* 设置绝对最大宽度 */
  --max-height: 80vh; /* 限制最大高度为视窗高度的80% */
  overflow-y: auto; /* 内容超出时显示滚动条 */
}
</style>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/theme/ai-theme.less";

.page-cover {
  padding: 1rem 1.5rem;
  position: relative;
  box-sizing: content-box;
  max-width: 100%;

  &_audio {
    width: 5vw;
    cursor: pointer;
    vertical-align: middle;
    margin-left: 2vw;
  }

  &_word {
    width: 100%;
    max-height: 100%;
    overflow-y: auto;

    h3 {
      font-size: 0.9rem;
      font-weight: 700;
      margin-bottom: 0;
      word-break: break-word; /* 长单词或句子自动换行 */
      overflow-wrap: break-word;
    }

    p {
      color: #868f9e;
      font-weight: 400;
    }

    .phonetic {
      margin: 0 0 0.3rem;
      font-size: 0.8rem;
    }

    &-button {
      &::part(native) {
        --background: #2bca9c;
        font-size: 0.8rem;
        --box-shadow: none;
      }
    }

    .ai-vocabulary {
      &::part(native) {
        --background: transparent;
        --border-color: #2bca9c;
        color: #2bca9c;
      }
    }

    #ai-sentence-audio {
      font-weight: 400;
    }
  }

  .translate {
    list-style: none;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    max-height: 40vh; /* 限制翻译部分高度 */

    &-content {
      font-size: 0.7rem;
    }

    /* 滚动条样式 */

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }
  }
}
</style>
